<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-shipping">      
      <div class="card">
        <div class="card-title align-items-center">
          <div class="d-flex pb-2 justify-content-start align-items-center">
            <button
              type="button"
              class="btn btn-icon btn-outline-primary"
              rippleEffect
              (click)="Back()"
            >
              <span [data-feather]="'arrow-left'"></span>
            </button>
            <h4 class="ml-50">Atrás</h4>
          </div>
          <div class="row">
            <div class="col-md-4">
              <label class="form-label" for="shippingType-input">
                <b class="text-primary">*</b> Tipo de envío: 
            </label>
            <ng-select [(ngModel)]="selectedShippingType" (change)="FetchShippingsByType()" aria-describedby="shippingType-input" [items]="shippingTypes" bindLabel="name" bindValue="id" placeholder="Tipos de envío"
             notFoundText="No hay información">
            </ng-select>
            </div>    
            <div class="col-md-4"></div>  
            <div class="col-md-4"></div> 
          </div>   
          <div class="row pt-1 align-items-center">
            <div class="col-md-4">
              <label class="form-label" for="select-shipping">
                <b class="text-primary">*</b> Envíos:
              </label>
              <ng-select
                id="select-shipping"
                [items]="shippings"
                bindLabel="code"
                placeholder="Seleccione un envío"
                [(ngModel)]="selectedShipping"
                (change)="GetFlightByShippingId()"
                notFoundText="No hay envíos"
              >
              </ng-select>
            </div>
            <div class="col-md-4">
              <label class="form-label" for="select-flights">
                <b class="text-primary">*</b> Vuelos:
              </label>
              <ng-select
                id="select-flights"
                [items]="flights"
                bindLabel="code"
                placeholder="Seleccione un vuelo"
                [(ngModel)]="selectedFlight"                
                notFoundText="No hay vuelos"
              >
              </ng-select>
            </div>
            <div class="col-md-4">
              <button
                type="button"
                class="btn btn-primary mt-2"
                rippleEffect
                (click)="asignBash()"
                [disabled]="selectedShipping === null || selectedFlight === null || selectedBills.length === 0"
              >
                Asignar
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-12">
              <div
                class="d-flex justify-content-between align-items-center m-1"
              >
                <label class="d-flex align-items-center"
                  >Mostrando
                  <select
                    class="form-control mx-25"
                    [(ngModel)]="basicSelectedOption"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option *ngIf="bills.length > 15" [value]="bills.length">
                      Todos
                    </option>
                  </select>
                  facturas</label
                >
              </div>
            </div>
            <div class="col-md-6 col-12 d-flex justify-content-md-end">
              <div
                class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0"
              >
                <label class="d-flex align-items-center"
                  >Buscar<input
                    #searchInput
                    type="search"
                    placeholder="Código Factura"
                    class="form-control ml-25"
                    (keyup)="FilterUpdate(searchInput.value)"
                    (search)="FilterUpdate(searchInput.value)"
                /></label>
              </div>
            </div>
          </div>
        </div>
        <ngx-datatable
          [rows]="bills"
          [rowHeight]="58"
          class="bootstrap core-bootstrap"
          [columnMode]="ColumnMode.force"
          [headerHeight]="40"
          [footerHeight]="50"
          [scrollbarH]="true"
          [limit]="basicSelectedOption"
          [selectionType]="SelectionType.checkbox"
          [selected]="selectedBills"
          [messages]="{
            emptyMessage: 'No hay información para mostrar',
            totalMessage: 'Total de facturas'
          }"
          (select)="onSelect($event)"
        >
          <ngx-datatable-column
            [width]="50"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [checked]="allRowsSelected"
                  (change)="selectFn(!allRowsSelected)"
                  id="headerChkbxRef"
                />
                <label
                  class="custom-control-label"
                  for="headerChkbxRef"
                ></label>
              </div>
            </ng-template>
            <ng-template
              ngx-datatable-cell-template
              let-rowIndex="rowIndex"
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
            >
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [checked]="isSelected"
                  (change)="onCheckboxChangeFn($event)"
                  id="rowChkbxRef{{ rowIndex }}"
                />
                <label
                  class="custom-control-label"
                  for="rowChkbxRef{{ rowIndex }}"
                ></label>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Código" prop="id">
            <ng-template let-id="value" ngx-datatable-cell-template>              
              <a (click)="DownloadPdf(id)" target="_self" placement="right"
                  ngbTooltip="Descargar pdf">
                    {{ GetCodeById(id) }}</a
                  >
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Origen" prop="senderModel">
            <ng-template let-sender="value" ngx-datatable-cell-template>
              <div placement="left" [ngbTooltip]="'Telefono: ' + sender?.Phone">
                <span
                  class="d-inline-block text-truncate"
                  style="max-width: 150px"
                  >{{ sender?.Name | limitText }}</span
                >
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Destino" prop="customerModel">
            <ng-template let-customer="value" ngx-datatable-cell-template>
              <div
                placement="left"
                [ngbTooltip]="'Telefono: ' + customer?.Phone"
              >
                <span
                  class="d-inline-block text-truncate"
                  style="max-width: 150px"
                  >{{ customer?.Name | limitText }}</span
                >
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Total" prop="total">
            <ng-template let-total="value" ngx-datatable-cell-template>
              <span>{{ total | currency }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Creada" prop="createAt">
            <ng-template let-createAt="value" ngx-datatable-cell-template>
              <span>{{ createAt | date : "mediumDate" }}</span>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </section>
  </div>
</div>
